export const controlIcons = {
    chevronRight: 'chevron-right',
    chevronLeft: 'chevron-left'
};
